import React from 'react';
import FrameFlow from '@/asserts/images/big-overview.png';
import FrameFlowWoa from '@/asserts/images/big-overview-woa.png';

import { getSite, PLATFORM } from '@/common/constants/platform-constants';
import s from './index.module.less';

const ImageContent = () => (
  <img className={s.flow} src={getSite() === PLATFORM.STANDALONE_WOA ? FrameFlowWoa : FrameFlow} alt="" />
);

export default ImageContent;
